export function spaceMemberUserIds(
  spaceGrants: ReadonlyArray<{
    userGroupId?: string | null;
    userId?: string | null;
  }>,
  memberUserIds: ReadonlyMap<string, readonly string[]>
): Set<string> {
  const ids = new Set<string>();
  for (const g of spaceGrants) {
    if (g.userId) ids.add(g.userId);
    if (g.userGroupId) {
      for (const uid of memberUserIds.get(g.userGroupId) ?? []) ids.add(uid);
    }
  }
  return ids;
}

export function countSpaceMembers(
  spaceGrants: ReadonlyArray<{
    userGroupId?: string | null;
    userId?: string | null;
  }>,
  memberUserIds: ReadonlyMap<string, readonly string[]>
): number {
  return spaceMemberUserIds(spaceGrants, memberUserIds).size;
}
